<template>
  <div id="reportes">
    <div
      class="col-12 text-left pt-2"
      data-aos="fade-right"
      data-aos-delay="100"
    >
      
    </div>

    <div
      class="separador text-center py-5"
      data-aos="fade-up"
      data-aos-delay="0"
    >
    <div class="mt-5 pt-5">&nbsp;</div>
      <p class="fXG blanco">Reportes</p>
    </div>

    <section data-aos="fade-up" data-aos-delay="200">
      <div class="container">
        <div class="row pb-5">
          <div class="col-12 col-lg-6 offset-lg-3">
            <div class="row">
              <div class="col-12">
                <form v-if="showLoginForm" @submit="login($event)">
                  <div class="col-12 text-center pb-4">
                    <h2>
                      <span class="bold blanco">Inicia sesión</span>
                    </h2>
                  </div>
                  <div class="d-flex flex-column pb-4">
                    <div class="w-100 px-2">
                      <input
                        v-model.trim="loginForm.email"
                        type="text"
                        placeholder="E-mail"
                        id="email1"
                        required
                      />
                    </div>
                    <div class="w-100 px-2">
                      <input
                        v-model.trim="loginForm.password"
                        type="password"
                        placeholder="Contraseña"
                        id="password1"
                        required
                      />
                    </div>
                    <div
                      class="w-100 px-2 text-center d-flex align-items-center"
                    >
                      <button
                        type="submit"
                        class="
                          amarillo
                          pointer
                          d-flex
                          align-items-center
                          justify-content-center
                          btnaction
                          fG
                          ml-auto
                          mr-auto
                          w-100
                        "
                      >
                        Continuar
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section data-aos="fade-up" data-aos-delay="200">
      <div class="container py-5">
        <div class="row text-center">
          <div class="col-12">
            <router-link
              to="/"
              class="
                amarillo
                pointer
                d-flex
                align-items-center
                justify-content-center
                btnaction
                fG
                ml-auto
                mr-auto
                w-100
              "
            >
              Ir al home
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("loginReportes", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.showMonedero = true;
    },
    async registro(monedero = "") {
      this.signupForm.monedero = monedero;
      console.log({ registro: this.signupForm });
      await this.$store.dispatch("signup", this.signupForm);

      this.showMonedero = false;
      this.resetForm();
      this.toggleForm();
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
